var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookAppSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 158.302,
    height: 304.854,
    viewBox: "0 0 158.302 304.854",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook-app-symbol",
    transform: "translate(-37.29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "f_1_",
    d: "M140.05,304.854V165.806H186.7l7-54.206H140.05V77c0-15.689,4.339-26.381,26.862-26.381l28.68-.012V2.122A388.88,388.88,0,0,0,153.791,0C112.414,0,84.085,25.257,84.085,71.63V111.6H37.29v54.206h46.8V304.854Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookAppSymbol);
export default __webpack_public_path__ + "static/media/facebook-app-symbol.005c20697179a3d22dfc793775706981.svg";
export { ForwardRef as ReactComponent };